import styled from 'styled-components';

const NumberChartWrapper = styled.div`
  height: calc(100% - 30px);
  .label {
    font-size: 24px;
  }
  .value {
    font-size: 40px;
  }
  .currenySymbol {
    font-size: 36px;
  }
`;

export { NumberChartWrapper };
